<template>
  <div>
    <ThePageHeader></ThePageHeader>
    <slot />
    <ThePageFooter />
  </div>
</template>

<script setup>
import ThePageFooter from '@/components/page/ThePageFooter.vue'
import ThePageHeader from '@/components/page/ThePageHeader.vue'
</script>
